$shm_ba_dashboard_indicators $mol_pick
	dashboard_id \
	options /string
	selected? /string
	align \bottom_left
	hint \Настроить показатели
	trigger_content /
		<= Menu_trigger_icon $mol_icon_settings
	bubble_content /
		<= Menu_content $mol_view
			sub /
				<= Menu_head $mol_view
					sub /
						<= Menu_title $mol_text
							text \Показатели:
						<= All $mol_check_box
							title \Все
							checked? <=> all_checked? false
				<= Indicators_drop $mol_drop
					allow /
						\move
					adopt? <=> indicator_adopt? null
					receive? <=> indicator_receive_end? null
					Sub <= Indicators $mol_list
						rows <= indicator_rows /$mol_view
	indicator_order? /string
	Indicator_row* $mol_drag
		allow_copy false
		allow_link false
		transfer *
			^
			text/plain <= indicator_transfer* \
		Sub <= Indicator_drop* $mol_drop
			allow /
				\move
			adopt? <=> indicator_adopt? null
			receive? <=> indicator_receive_before*? null
			Sub <= Indicator_content* $mol_view
				sub /
					<= Indicator_drag_icon* $mol_icon_drag_vertical
					<= Indicator*
	Indicator* $mol_check_box
		title <= indicator_title* \
		checked? <=> indicator_checked*? false
